/**
 * API Configuration
 * In development, we use the vite proxy (relative URLs)
 * In production, we call the worker directly
 */

const WORKER_URL = 'https://integra-docusign-worker.dfisher-3f3.workers.dev';

// Use relative URLs in development (vite proxy handles them)
// Use worker URL in production
export const API_BASE_URL = import.meta.env.DEV ? '' : WORKER_URL;

/**
 * Make an API request with the correct base URL
 */
export async function apiRequest(
  path: string,
  options: RequestInit = {}
): Promise<Response> {
  const url = `${API_BASE_URL}${path}`;
  return fetch(url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });
}

/**
 * Get the OAuth start URL
 */
export function getOAuthStartUrl(): string {
  return `${API_BASE_URL}/oauth/start`;
}
